import { apiDownload, apiFetch } from "../../../lib/api/client";
import {
  materialPageSchema,
  materialSchema,
  materialVersionSchema,
  type Material,
  type MaterialDraft,
} from "../schemas/materialSchemas";

export async function listMaterials(query = "") {
  return materialPageSchema.parse(
    await apiFetch(`/materials?query=${encodeURIComponent(query)}`),
  );
}
export async function getMaterial(id: string): Promise<Material> {
  return materialSchema.parse(await apiFetch(`/materials/${id}`));
}
export async function createMaterial(values: MaterialDraft): Promise<Material> {
  return materialSchema.parse(
    await apiFetch("/materials", {
      method: "POST",
      body: JSON.stringify(values),
    }),
  );
}
export async function createMaterialWithFile(
  values: MaterialDraft,
  file: File,
  rights: boolean,
): Promise<Material> {
  const body = new FormData();
  body.set("title", values.title);
  body.set("description", values.description);
  body.set("file", file);
  body.set("publicationRightsConfirmed", String(rights));
  return materialSchema.parse(
    await apiFetch("/materials/with-file", { method: "POST", body }),
  );
}

export async function updateMaterial(
  material: Material,
  values: MaterialDraft,
): Promise<Material> {
  return materialSchema.parse(
    await apiFetch(`/materials/${material.id}`, {
      method: "PUT",
      headers: { "If-Match": `W/"${material.rowVersion}"` },
      body: JSON.stringify(values),
    }),
  );
}
export async function uploadVersion(
  materialId: string,
  file: File,
  rights: boolean,
  releaseNotes = "",
) {
  const body = new FormData();
  body.set("file", file);
  body.set("publicationRightsConfirmed", String(rights));
  body.set("releaseNotes", releaseNotes);
  return materialVersionSchema.parse(
    await apiFetch(`/materials/${materialId}/versions`, {
      method: "POST",
      body,
    }),
  );
}
export async function materialCommand(
  material: Material,
  command: "review" | "publish" | "withdraw",
): Promise<Material> {
  return materialSchema.parse(
    await apiFetch(`/materials/${material.id}/${command}`, {
      method: "POST",
      headers: { "If-Match": `W/"${material.rowVersion}"` },
    }),
  );
}
export async function downloadMaterialFile(
  materialId: string,
  versionId: string,
) {
  return apiDownload(`/materials/${materialId}/versions/${versionId}/download`);
}
export async function deleteMaterial(material: Material): Promise<void> {
  return apiFetch("/materials/" + material.id, {
    method: "DELETE",
    headers: { "If-Match": 'W/"' + material.rowVersion + '"' },
  });
}
